import React from 'react'
import { useDispatch } from 'react-redux'
import Overlay from 'common/components/core/Overlay'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { closePopup } from 'publisher/actionsManagement'
import Popup from 'publisher/components/entities/Popup'
import { PopupNew } from 'publisher/components/entities/popup-new'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import { PopupWrapperUi } from 'publisher/pages/ui/popup-wrapper-ui'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { setCloseCookie } from 'publisher/utils/cookie'

export const BlogTriggeredPopup = () => {
  const triggeredPopupId = useManagement(managementSelectors.getActivePopupId)
  const popup = usePage(page =>
    pageSelectors.getEntityById(page, triggeredPopupId),
  ) as PopupInterface | OldEntityInterface
  // we could have global popups available on all pages and posts
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const dispatch = useDispatch()

  if (!popup) {
    return null
  }

  const handleClose = (popupId: string, closedDays: number | undefined) => {
    setCloseCookie(blogLayoutPageId, popupId, closedDays)
    dispatch(closePopup)
  }

  return (
    <React.Fragment>
      <PopupWrapperUi>
        {popup.type === EntityTypeEnum.Popup ? (
          <PopupNew
            entity={popup}
            closePopup={() => handleClose(popup.id, popup.closedDays)}
          />
        ) : (
          <Popup
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            entity={popup as any}
            overflow="auto"
            closePopup={() => handleClose(popup.id, popup.options.closedDays)}
          />
        )}
      </PopupWrapperUi>
      <Overlay dark />
    </React.Fragment>
  )
}
